import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import CoterieLogoSVG from '../../assets/img/coterie_logo.svg';
import { clearAllData } from '../../actions/application';
import { isLocal, isTest } from '../../helpers/environment';

interface LogoProps {
  clearAllData: () => void;
}

const LogoComp = ({ clearAllData }: LogoProps) => {
  const handleClick = () => {
    if (isLocal() || isTest()) {
      clearAllData();
    }
  };
  return <Logo src={CoterieLogoSVG} alt="Coterie Logo" onClick={handleClick} />;
};

const Logo = styled.img`
  margin-top: 40px;
  margin-bottom: 60px;
`;

const mapDispatchToProps = { clearAllData };

export default connect(null, mapDispatchToProps)(LogoComp);
